module.exports = __webpack_public_path__ + "static/media/siddharth-mysuru-trip-39.3ef7ff1e.png";